import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import Seo from "@/components/site/Seo";
import EnquiryForm from "@/components/site/EnquiryForm";
import { PageHero } from "@/components/site/kit";
import { CONSENT, CONTACT_FIELDS } from "@/lib/forms";
import { CONTACT } from "@/lib/site";

const ROUTES = [
  ["Players", "/players/register", "Player registration"],
  ["Franchise", "/franchise#eoi", "Franchise expression of interest"],
  ["Sponsors", "/sponsors#enquiry", "Sponsorship enquiry"],
  ["Media", "/media#enquiry", "Media & broadcasting enquiry"],
];

export default function Contact() {
  return (
    <>
      <Seo title="Contact" description="Contact the Telangana–Andhra T10 League and CGN Sports." />
      <PageHero testid="contact-hero" eyebrow="Contact" title="Get in Touch" image="/images/hyderabad-night.jpg">Questions about the league? Reach the CGN Sports team directly.</PageHero>
      <section className="container-x grid gap-10 py-16 lg:grid-cols-[360px_1fr]">
        <aside className="space-y-4">
          <a href={`mailto:${CONTACT.email}`} data-testid="contact-email" className="card-lift flex items-center gap-4 rounded-md border border-white/10 bg-[#112240] p-5">
            <Mail className="h-6 w-6 text-[#00E5FF]" /><div><p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Email</p><p className="font-semibold">{CONTACT.email}</p></div>
          </a>
          <a href={`tel:${CONTACT.tel}`} data-testid="contact-phone" className="card-lift flex items-center gap-4 rounded-md border border-white/10 bg-[#112240] p-5">
            <Phone className="h-6 w-6 text-[#FF5722]" /><div><p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Phone</p><p className="font-semibold">{CONTACT.phone}</p></div>
          </a>
          <div className="rounded-md border border-white/10 bg-[#112240] p-5">
            <p className="mb-3 text-[10px] font-bold uppercase tracking-widest text-slate-400">Specific enquiries</p>
            <ul className="space-y-2 text-sm">{ROUTES.map(([k, to, l]) => <li key={k}><Link to={to} className="text-slate-200 hover:text-[#00E5FF]">{l} →</Link></li>)}</ul>
          </div>
        </aside>
        <EnquiryForm testid="contact-form" fields={CONTACT_FIELDS} endpoint="/forms/contact" submitLabel="Send Message" consentText={CONSENT}
          success="Thank you for contacting the Telangana–Andhra T10 League. Our team will get back to you shortly." />
      </section>
    </>
  );
}
